<template>
    <v-select
        :items="items"
        :label="label"
        :hint="hint"
        :readonly="readonly"
        :value="value"
        :multiple="multiple"
        :rules="requiredRules"
        :class="styleClasses"
        @change="changeItem"
        @input="changeItem"
        >
    </v-select>
</template>
<script>
import { requiredRules } from '../../utils/rules'

export default {

  name: 'HttpMethodSelect',

  methods: {
    changeItem (event) {
      this.$emit('change', event)
    }
  },

  mounted () {
    if (this.hideGet) {
      this.items.splice(0, 1)
    }
  },

  data: () => ({
    items: ['GET', 'POST', 'DELETE', 'PUT']
  }),

  model: {
    prop: 'value',
    event: 'change'
  },

  computed: {
    requiredRules () {
      return this.required ? requiredRules(this.value) : []
    }
  },

  props: {
    label: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: true
    },
    styleClasses: {
      type: String,
      default: null
    },
    hideGet: {
      type: Boolean,
      default: false
    }
  }
}
</script>
